import { combineReducers } from 'redux';
import diffusion from './diffusion';

export const diffusionReducer = combineReducers({
  selection: diffusion,
});



// WEBPACK FOOTER //
// ./src/modules/diffusion/reducers/index.js